<template>

  <vx-card class="p-0" :title="(id ? $t('update_a') : $t('new')) + ' ' + $t('school_year')">
    <form-wizard v-if="formwizard1" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit">
      <tab-content :key="indexItem" v-for="(item, indexItem) in niveaus" :title="item.libelle" class="mb-5" :before-change="step_validate(item.id)">
        <!-- tab 1 content -->
        <form :data-vv-scope="'step-' + item.id">
          <div class="vx-row">
            <div @mouseover="id_general = item.id" class="vx-col w-full mt-5">
              <p class="mt-4" > {{ $t('types_of_partitions') }} <b style="color: #ff6141">*</b> </p>
              <v-select :options="typePartitions[item.id]" @search="getTypePartition" :clearable="true" label="libelle" v-model="niveau_type_partition_input[item.id].typePartition" class="w-full" :name="'typePartition' + item.id" v-validate="'required'"/>
              <span class="text-danger">{{ errors.first(errorsFirst(item.id)) }}</span>
            </div>

            <div :key="partitionindexItem" v-for="(partition, partitionindexItem) in niveau_type_partition_input[item.id].partitions" class="vx-col md:w-1/2 w-full mt-5">
              <vs-list>
                <vs-list-header icon-pack="feather" icon="icon-crop" :title="'Partition ' + (partitionindexItem + 1)"></vs-list-header>
                <vs-list-item icon-pack="feather" icon="icon-check" title="Libelle" :subtitle="partition.long_label"></vs-list-item>
                <vs-list-item icon-pack="feather" icon="icon-check" title="Libelle court" :subtitle="partition.short_label"></vs-list-item>
              </vs-list>
            </div>
          </div>
        </form>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content v-if="formwizard" :title="$t('school_year')" class="mb-5" :before-change="school_year_validate">
        <form data-vv-scope="school_year">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">

            <p class="mt-4" > {{ $t('Start_year') }} <b style="color: #ff6141">*</b> </p>
            <v-select :options="annees" @search="getAnnee" :clearable="true" label="valeur" v-model="annee_scolaire_input.anneeDebut" class="w-full" name="anneeDebut" v-validate="'required'"/>
            <span class="text-danger">{{ errors.first('school_year.anneeDebut') }}</span>

            <p class="mt-4" > {{ $t('End_year') }} <b style="color: #ff6141">*</b> </p>
            <v-select :options="annees1" @search="getAnnee1" :clearable="true" label="valeur" v-model="annee_scolaire_input.anneeFin" class="w-full" name="anneeFin" v-validate="'required'" />
            <span class="text-danger">{{ errors.first('school_year.anneeFin') }}</span>

          </div>
          <div class="vx-col md:w-1/2 w-full">
            <p class="mt-4" > {{ $t('Start_date') }} <b style="color: #ff6141">*</b> </p>
            <datepicker v-model="annee_scolaire_input.dateDebut" name="dateDebut" v-validate="'required'"></datepicker>
            <span class="text-danger">{{ errors.first('school_year.dateDebut') }}</span>
          </div>
        </div>
        </form>
      </tab-content>

    </form-wizard>
  </vx-card>
</template>

<script>
let base_self = ''
import Datepicker from 'vuejs-datepicker'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// For custom error message
import { Validator } from 'vee-validate'

const annee_scolaire_input_tempon = {
  encours: true,
  cloture: false,
  libelle: '',
  anneePrecedente: '',
  // à remplir
  dateDebut: new Date(),
  anneeFin: '',
  anneeDebut: ''
}

const niveau_type_partition_input_tempon = {
  anneeScolaire: '',
  niveau: '',
  typePartition: '',
  partitions: []
}

const nombre = {}

export default {
  watch: {
    niveau_type_partition_input: {
      handler  () {
        const length = base_self.niveaus.length
        for (let i = 0; i < length; i++) {
          const item = base_self.niveaus[i]

          if (base_self.niveau_type_partition_input[item.id].typePartition && base_self.niveau_type_partition_input1[item.id].typePartition.id !== base_self.niveau_type_partition_input[item.id].typePartition.id) {
            const item1 = base_self.niveau_type_partition_input[item.id].typePartition
            const partitions = []
            for (let j = 0; j < item1.number_of_partitions; j++) {
              partitions.push({
                short_label: `${nombre[j + 1].short_label} ${item1.libelle}`,
                long_label: `${nombre[j + 1].long_label} ${item1.libelle}`
              })
            }

            base_self.niveau_type_partition_input[item.id].partitions = partitions
          }
        }

        base_self.niveau_type_partition_input1 = JSON.parse(JSON.stringify(base_self.niveau_type_partition_input))
        // base_self.niveau_type_partition_input = JSON.parse(JSON.stringify(base_self.niveau_type_partition_input))
      },
      deep: true
    }
  },
  data () {
    return {
      formwizard1: false,
      formwizard: false,
      desired: true,
      niveau_type_partition_input: {},
      niveau_type_partition_input1: {},
      typePartitions: {},
      id_general: '',
      niveaus: [],
      annee_scolaire_encours: null,
      annee_scolaire_input: JSON.parse(JSON.stringify(annee_scolaire_input_tempon)),
      annees: [],
      annees1: []
    }
  },
  methods: {
    errorsFirst (id) {
      return `step-${id}.typePartition${id}`
    },
    getTypePartition (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypePartition`, data)
        .then((response) => {
          base_self.typePartitions[base_self.id_general] = response.data.data
          base_self.typePartitions = JSON.parse(JSON.stringify(base_self.typePartitions))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getAnnee (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { valeur__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Annee`, data)
        .then((response) => {
          base_self.annees = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getAnnee1 (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { valeur__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Annee`, data)
        .then((response) => {
          base_self.annees1 = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    step_validate (id) {
      const libelle = `step-${id}`
      const validate = () => {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll(libelle).then(result => {
            if (result) {
              resolve(true)
            } else {
              reject('correct all values')
            }
          })
        })
      }

      return validate
    },
    school_year_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('school_year').then(result => {
          if (result) {
            base_self.submit()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    finaliserOuvertureAnne () {
      const data = {
        id: base_self.annee_scolaire_encours.id,
        encours: false
      }

      base_self.$http.put(`${base_self.$store.state.route_for_esm}AnneeScolaire`, data)
        .then((response) => {
          window.getESM.success(base_self.$t('The_school_year_is_added_successfully'), response)
          base_self.$router.push('/year_opening_management/school_years/').catch(() => {})
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    afterSubmit (data) {
      const niveau_type_partition_input = JSON.parse(JSON.stringify(base_self.niveau_type_partition_input))

      const length = base_self.niveaus.length
      const niveauTypePartitions = []
      for (let i = 0; i < length; i++) {
        const item = base_self.niveaus[i]
        niveau_type_partition_input[item.id].anneeScolaire = data.id
        niveau_type_partition_input[item.id].typePartition = niveau_type_partition_input[item.id].typePartition.id

        niveauTypePartitions.push(niveau_type_partition_input[item.id])
      }

      // many data
      const input = {
        many: true,
        data: niveauTypePartitions
      }

      base_self.$vs.loading()
      base_self.$http.post(`${base_self.$store.state.route_for_esm}NiveauTypePartition`, input)
        .then(() => {
          // console.log('response: ', response)
          // window.getESM.success(base_self.$t('The_school_year_is_added_successfully'), response)
          base_self.finaliserOuvertureAnne()
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    submit () {
      const annee_scolaire_input = JSON.parse(JSON.stringify(base_self.annee_scolaire_input))
      annee_scolaire_input.libelle = `${annee_scolaire_input.anneeDebut.valeur} - ${annee_scolaire_input.anneeFin.valeur}`
      annee_scolaire_input.anneeDebut = annee_scolaire_input.anneeDebut.id
      annee_scolaire_input.anneeFin = annee_scolaire_input.anneeFin.id

      base_self.$vs.loading()
      base_self.$http.post(`${base_self.$store.state.route_for_esm}AnneeScolaire`, annee_scolaire_input)
        .then((response) => {
          console.log('response: ', response)
          base_self.afterSubmit(response.data.data)
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    creerAnneeDeFin (valeur) {
      return new Promise((resolve, reject) => {
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Annee`, { valeur })
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            console.log('error: ', error)
            reject(error)
          })
      })
    },
    rechercherAnneeDeFin (valeur) {
      const data = {
        is_get: true,
        filter: { valeur }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Annee`, data)
        .then(async (response) => {
          if (response.data.data.length) {
            base_self.annee_scolaire_input.anneeFin = response.data.data[0]
          } else {
            base_self.annee_scolaire_input.anneeFin = await base_self.creerAnneeDeFin(valeur)
          }

          base_self.annee_scolaire_input.anneeDebut = base_self.annee_scolaire_encours.anneeFin
          base_self.annee_scolaire_input.anneePrecedente = base_self.annee_scolaire_encours.id
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    comfirmerSiTousLesAnneesSontCloturer () {
      const data = {
        is_get: true,
        filter: { cloture: false }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}AnneeScolaire`, data)
        .then((response) => {
          if (response.data.data.length) {
            base_self.$router.push('/year_opening_management/school_years').catch(() => {})
          } else {
            base_self.rechercherAnneeEnCours()
          }
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    rechercherAnneeEnCours () {
      const data = {
        is_get: true,
        filter: { encours: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}AnneeScolaire`, data)
        .then((response) => {
          if (response.data.data.length) {
            base_self.annee_scolaire_encours = response.data.data[0]
            base_self.rechercherAnneeDeFin(base_self.annee_scolaire_encours.anneeFin.valeur + 1)
          }
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    initialiseElement () {
      nombre[1] = { short_label: base_self.$t('First_1st'), long_label: base_self.$t('First') }
      nombre[2] = { short_label: base_self.$t('Second_2nd'), long_label: base_self.$t('Second') }
      nombre[3] = { short_label: base_self.$t('Third_3rd'), long_label: base_self.$t('Third') }
      nombre[4] = { short_label: base_self.$t('Fourth_4th'), long_label: base_self.$t('Fourth') }
      nombre[5] = { short_label: base_self.$t('Fifth_5th'), long_label: base_self.$t('Fifth') }

      const dict = {
        custom: {
          anneeDebut: {
            required: base_self.$t('The_start_year_is_required')
          },
          anneeFin: {
            required: base_self.$t('The_end_year_is_required')
          },
          dateDebut: {
            required: base_self.$t('The_start_date_is_required')
          }
        }
      }
      const length = base_self.niveaus.length
      for (let i = 0; i < length; i++) {
        const item = base_self.niveaus[i]
        base_self.typePartitions[item.id] = []
        base_self.niveau_type_partition_input[item.id] = JSON.parse(JSON.stringify(niveau_type_partition_input_tempon))
        base_self.niveau_type_partition_input[item.id].niveau = item.id

        dict.custom[`typePartition${item.id}`] = {
          required: base_self.$t('The_partition_type_is_required')
        }
      }

      base_self.niveau_type_partition_input = JSON.parse(JSON.stringify(base_self.niveau_type_partition_input))
      // register custom messages
      Validator.localize('en', dict)
      base_self.formwizard1 = true

      function sayHi () {
        base_self.formwizard = true
      }

      setTimeout(sayHi, 2000)
    },
    async getNiveaus () {
      const param = {
        is_get: true,
        filter: {
          is_active: true
        },
        orderby: ['ordre']
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, param)
        .then((response) => {
          base_self.niveaus = response.data.data
          base_self.initialiseElement()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    }
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent
  },
  created () {
    base_self = this
    base_self.comfirmerSiTousLesAnneesSontCloturer()
    base_self.getNiveaus()
  }
}
</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
